// extracted by mini-css-extract-plugin
module.exports = {"root":"WarningBoxView_root__Mzns_","rootIcon":"WarningBoxView_rootIcon__Se4kv","title":"WarningBoxView_title__UM3oW","text":"WarningBoxView_text__QlaqP"};